export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('app.admin.basket-create', {
            url: '/baskets/create',
            component: 'basketCreate',
            resolve: {
                title: () => 'Create a Basket'
            },
            roles: ['manager']
        })
        ;
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/basket.routes.js